import React from "react";
import {
  Compass,
  TrendingUp,
  Users,
  HeartHandshake,
  Sprout,
  MapPin,
  GraduationCap,
  PieChart,
} from "lucide-react";

const OUTCOMES = [
  { icon: Compass, label: "A shared understanding of Country" },
  { icon: TrendingUp, label: "Stronger funding and project proposals" },
  {
    icon: Users,
    label: "Knowledge transfer between Elders, rangers and young people",
  },
  { icon: HeartHandshake, label: "Support for Healthy Country Planning" },
  { icon: Sprout, label: "Restoration and conservation planning" },
  { icon: MapPin, label: "Tourism and interpretation materials" },
  { icon: GraduationCap, label: "Community education resources" },
  {
    icon: PieChart,
    label: "Visual communication tools for partners and stakeholders",
  },
];

export default function WhyBushMapping() {
  return (
    <section
      id="why-bush-mapping"
      data-testid="section-why-bush-mapping"
      className="relative py-24 md:py-32 bg-[#F3EFEA]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left — heading & intro */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="bm-eyebrow mb-6">Section 03 — Why</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2621]">
              Why Bush Mapping?
            </h2>
            <div className="mt-8 space-y-5 text-[#584D45] text-lg leading-relaxed">
              <p>
                Many communities hold deep knowledge about Country, but that
                knowledge is often spread across reports, management plans,
                species surveys, oral histories and individual experience.
              </p>
              <p className="font-serif-display italic text-2xl text-[#2C3C2B]">
                Bush Mapping brings these knowledge systems together.
              </p>
            </div>
          </div>

          {/* Right — outcomes list */}
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.28em] uppercase text-[#7A6C63] mb-8">
              Bush Mapping creates
            </div>
            <ul className="grid sm:grid-cols-2 gap-px bg-[#C5B6A3]/60">
              {OUTCOMES.map(({ icon: Icon, label }, i) => (
                <li
                  key={label}
                  className="bg-[#FDFBF7] p-6 lg:p-7 flex items-start gap-4 group hover:bg-[#FFFCF6] transition-colors"
                >
                  <span className="w-11 h-11 rounded-full bg-[#EBE4D8] border border-[#C5B6A3] flex items-center justify-center text-[#A95A3F] shrink-0 group-hover:bg-[#A95A3F] group-hover:text-white group-hover:border-[#A95A3F] transition-colors">
                    <Icon size={18} />
                  </span>
                  <div>
                    <div className="text-[10px] tracking-[0.24em] uppercase text-[#C5B6A3] font-semibold mb-1">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="text-[#2D2621] text-base md:text-[17px] leading-snug">
                      {label}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
